import { render, staticRenderFns } from "./CardStrategy.vue?vue&type=template&id=08f8dd40"
import script from "./CardStrategy.vue?vue&type=script&lang=js"
export * from "./CardStrategy.vue?vue&type=script&lang=js"
import style0 from "./CardStrategy.vue?vue&type=style&index=0&id=08f8dd40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports